import { render, staticRenderFns } from "./OrderWorkflowsDetailsForm.vue?vue&type=template&id=bf07f388&scoped=true"
import script from "./OrderWorkflowsDetailsForm.vue?vue&type=script&lang=js"
export * from "./OrderWorkflowsDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./OrderWorkflowsDetailsForm.vue?vue&type=style&index=0&id=bf07f388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf07f388",
  null
  
)

export default component.exports